import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute,NavigationExtras, RoutesRecognized } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import {FormGroup,FormControl,Validators} from '@angular/forms';
import { NavController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { ToastService } from 'src/app/services/toast.service';
import {Location} from '@angular/common';
import { UserService } from 'src/app/services/user.service';
@Component({
  selector: 'app-raise-issue',
  templateUrl: './raise-issue.page.html',
  styleUrls: ['./raise-issue.page.scss'],
})
export class RaiseIssuePage implements OnInit {
  issueType:any;
  mubileNumber:number;
  issueText:any;
  flag : any;
  a: any;
  check: any = 0;
  userId: any;
  constructor(private userService:UserService, private _location: Location,private toast : ToastService,private router: Router,private authService:StoreService,private routerActivate:ActivatedRoute,private navController : NavController) { }

  customerissue = new FormGroup({
    feedbackType : new FormControl("",Validators.required),

    feedbackMessage : new FormControl("",Validators.required)
  })
 
  get feedbackType(){
    return this.customerissue.get('feedbackType')
  }
  get feedbackMessage(){
    return this.customerissue.get('feedbackMessage')
  }
  ngOnInit() {
    this.routerActivate.queryParams.subscribe(res=>{
      if(this.router.getCurrentNavigation().extras.state){
     this.flag=this.router.getCurrentNavigation().extras.state.flag;
     console.log(this.flag);}
   })
   
  }
  goBack() {
    this.navController.back();
  }
  changeSuit(e){
    this.issueType=e.target.value
     console.log("change vales from time drop down",  this.issueType)
   }
   submitdata(){
      if(this.customerissue.valid){
        let data ={
          userid : localStorage.getItem('userId'),
          comment : this.customerissue.value.feedbackMessage,
          issue : this.customerissue.value.feedbackType

        }
      this.authService.customerSupport(data).subscribe((result:any)=>{
      console.log("requ creation",result)
      this.toast.presentToast("Your issue has successfully registered")
      this.customerissue.reset()
      });
      
  }
    let user = localStorage.getItem('userId');
    if (user=="undefined") {
    console.log("login your account1 ")
    this.router.navigate(['/loginmobile']);
    this.ionViewWillEnter()
  }
   }
//   submitdata(){
//       let data ={
//         userId : localStorage.getItem('userId'),
//         feedbackMessage : this.customerissue.value.feedbackType,
//         feedbackType : this.customerissue.value.feedbackMessage

//       }
//     this.authService.customerSupport(data).subscribe((result:any)=>{
//     console.log("requ creation",result)
//     this.toast.presentToast("Your message has successfully registered")
//     this.customerissue.reset()
//     });
    

//   let user = localStorage.getItem('userId');
//   if (user=="undefined") {
//   console.log("login your account1 ")
//   this.router.navigate(['/loginmobile']);
//   this.ionViewWillEnter()
// }
//  }
   ionViewWillEnter(){
    this.a=this.userService.uid;
    if(this.a){
      this.check=true;
    }else{
      this.check=false
    }
    let data={
      uid : this.a
    }
    this.userService.getUserDetails(data).subscribe((res:any)=>{
      console.log("userDetails",res);
      if(res){
        this.userId=res._id
        localStorage.setItem("userId", this.userId)
        console.log("dsfdg", this.userId)
      }
     
    })
  }
 
}
